<div
  *hasPermission="menuItemPermissions"
  [go]="data.view"
  [afterGo]="onAfterGo.bind(this)"
  #item
  [class]="'menuItem ' + dataClassPhoneDesktop() + ' ' + (class_ ? class_ : '')"
  [ngClass]="{ selected: menuS.isSelected(data), closed: !menuOpened }"
>
  @if (attentionIcon) {
    <mat-icon class="attention-icon c_o" style="transform: scale(0.6)" [filled]="true">
      fiber_manual_record
    </mat-icon>
  }

  @if (!svgIcon) {
    <mat-icon [filled]="menuS.isSelected(data)" class="c_w main-icon">{{ data.icon }}</mat-icon>
  }

  @if (svgIcon) {
    <mat-icon
      class="main-icon"
      [svgIcon]="getSvgIconName()"
      [ngClass]="{ filled: menuS.isSelected(data), c_w: !menuS.isSelected(data) }"
    ></mat-icon>
  }

  @if (menuOpened) {
    <span [ngClass]="{ mr20: matmenu, c_w: true }">
      {{ data.name }}
    </span>
  }

  <!-- Right icon-->
  @if (righticon) {
    <span
      class="span-icon"
      style="margin-right: 0px"
      [ngClass]="menuOpened ? 'right' : 'absolute'"
    >
      <mat-icon [filled]="true" [style]="'color : ' + righticon.color + ' !important;'">{{
        righticon.icon
      }}</mat-icon>
    </span>
  }
  <div class="expansionPanel" [ngClass]="{ closed: !menuOpened }"></div>
</div>
